import * as React from 'react';
import cn from 'classnames';
import { WarningRounded } from './Icons';
import * as css from './Notification.css';
const Notification = ({ className, children }) => {
    return (React.createElement("div", { className: cn(css.notification, className) },
        React.createElement("div", { className: css.icon }, WarningRounded),
        React.createElement("div", { className: css.content }, children)));
};
export default Notification;
